<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.groupinglist.MigrationGroup')" :visible.sync="dialogVisible" width="30%" center>
      <div style="text-align:center">
        <div>
          <span class="tetxp">n2n：</span>
          <el-select
            v-model="N2nData.serverId"
            :placeholder="$t('lang.groupinglist.selector')"
            class="admininput"
            size="mini"
            @change="GetN2nServer"
          >
            <el-option
              v-for="item in N2nList"
              :key="item.serverId"
              :label="item.serverName"
              :value="item.serverId"
            ></el-option>
          </el-select>
        </div>
        <div>
          <span class="tetxp">{{$t('lang.groupinglist.N2nVersion')}}：</span>
          <el-input size="mini" class="admininput" disabled v-model="N2nData.serverVersion"></el-input>
        </div>
        <div>
          <span class="tetxp">{{$t('lang.groupinglist.port')}}：</span>
          <el-input size="mini" class="admininput" disabled v-model="N2nData.port"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.groupinglist.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="updateGroupInfo">{{$t('lang.groupinglist.Determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getGroupList,
  modifyGroupName,
  deleteGroup,
  addGroup,
  getCustomerList,
  getAddLevel3Group,
  queryGroupKeyword,
  getUserList,
  GetListN2nServer,
  updateGroupInfo
} from "@/api/groupinglist";
export default {
  props:['N2nidList'],
  data() {
    return {
      dialogVisible: false,
      //当前选中n2n信息
      N2nData:{
        port:null,
        serverId:null,
        serverVersion:''
      },
      //所有n2n信息
      N2nList:[],
    };
  },
  methods: {
    show() {
      this.getN2N()
      this.dialogVisible = true;
    },
    getN2N() {
      //获取n2n服务列表
      GetListN2nServer(1,99999)
      .then((res)=>{
        this.N2nList=res.data.data.list
      })
    },
    //获取当前选中的n2n信息
    GetN2nServer(){
      this.N2nList.forEach((val,index)=>{
        if(val.serverId==this.N2nData.serverId){
          this.N2nData.port=val.serverPort
          this.N2nData.serverVersion=val.serverVersion
          return
        }
      })
    },
     //迁移n2n服务
    updateGroupInfo(){
      updateGroupInfo(
        this.N2nidList,
        this.N2nData.serverId,
        parseInt(this.N2nData.port)
      )
      .then((res)=>{
        if (res.data.code === 0) {
          this.$message({
            message: this.$t("lang.groupinglist.message15"),
            type: "success"
          });
          this.dialogVisible = false
        } else {
          this.$message({
            message: this.$t("lang.groupinglist.message16"),
            type: "warning"
          });
        }
      })
    },
  }
};
</script>
<style scoped>
.tetxp {
  display: inline-block;
  width: 1.8rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}
</style>